import { createSlice } from "@reduxjs/toolkit";
import * as AuthReducers from "../reducer/authReducers";
import { User } from "oidc-client-ts";

export interface QueryServiceData {
  cidClientSuffix: string | null;
  ncheckClientSuffix: string | null;
  nviewClientSuffix: string | null;
}

export const queryServiceDataFactory = () => {
  return {
    cidClientSuffix: null,
    ncheckClientSuffix: null,
    nviewClientSuffix: null,
  };
};

export interface AuthState {
  pid: string;
  email: string;
  displayName: string;
  provisionerCommonName: string;
  cnamCustomerId: string;
  userError: boolean;
  isLoading: boolean;
  isAdmin: boolean;
  userProfile: string;
  user: User;
  expires_at: number;
  queryServiceData: QueryServiceData;
}

const initAuthState = (): AuthState => {
  return {
    pid: "",
    email: "",
    displayName: "",
    provisionerCommonName: "",
    cnamCustomerId: "",
    userProfile: "",
    userError: false,
    isLoading: false,
    isAdmin: false,
    expires_at: 0,
    user: {} as User, //all OIDC information
    queryServiceData: queryServiceDataFactory(),
  };
};

const authSlice = createSlice({
  name: "auth",
  initialState: initAuthState(),
  reducers: { ...AuthReducers },
});

const authActions = authSlice.actions;

export { authSlice, authActions };
